(function() {
  'use strict';

  var SAFETY_TIMEOUT = 6000; // timeout fallback for hanging apps
  var REBUY_SETTLE = 12000; // window for late rebuy products
  var MIN_LOADER_MS = 100; // floor, else the loader strobes
  var CFP_TEXT = 'Call for price';
  var productDataRequests = {};

  function getProductPath(link) {
    try {
      var url = new URL(link, window.location.origin);
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return null;
    }
  }

  // alternate view supplies missing metafields
  function getProductData(productPath) {
    if (!productDataRequests[productPath]) {
      productDataRequests[productPath] = fetch(productPath + '?view=card-data')
        .then(function(response) {
          if (!response.ok) throw new Error('product request failed');
          return response.json();
        })
        .then(function(data) {
          return { vendor: data.vendor || '', callForPrice: data.call_for_price === true };
        })
        .catch(function() {
          return { vendor: '', callForPrice: false };
        });
    }
    return productDataRequests[productPath];
  }

  // rebuy may replace enriched prices later
  function applyCallForPrice(card) {
    var priceEl = card.querySelector('.rebuy-product-price') || card.querySelector('.rebuy-money');
    if (!priceEl || priceEl.getAttribute('data-rec-cfp') === '1') return;
    priceEl.setAttribute('data-rec-cfp', '1');
    priceEl.classList.add('rec-cfp');
    priceEl.textContent = CFP_TEXT;
  }

  function applyProductData(card, title, data) {
    if (!document.contains(card)) return;

    if (data.vendor && document.contains(title) && !card.querySelector('.rebuy-product-vendor')) {
      var vendorElement = document.createElement('p');
      vendorElement.className = 'rebuy-product-vendor';
      vendorElement.textContent = 'By ' + data.vendor;
      title.insertAdjacentElement('afterend', vendorElement);
    }

    if (data.callForPrice) applyCallForPrice(card);
  }

  function enrichRebuyCard(card, title, productPath) {
    if (card.__recProductData) {
      applyProductData(card, title, card.__recProductData);
      return;
    }
    if (card.__recProductDataPending) return;

    card.__recProductDataPending = true;
    getProductData(productPath).then(function(data) {
      card.__recProductDataPending = false;
      card.__recProductData = data;
      applyProductData(card, title, data);
    });
  }

  function enrichRebuyCards(wrap) {
    if (!wrap.querySelector('[data-rebuy-id]')) return;

    var titles = wrap.querySelectorAll('.rebuy-product-title');
    for (var i = 0; i < titles.length; i++) {
      var title = titles[i];
      var card = title.closest('.rebuy-product-block');
      var link = title.querySelector('a') || (card && card.querySelector('.rebuy-product-media a'));
      var productPath = link && getProductPath(link.href);

      if (!card || !productPath) continue;
      enrichRebuyCard(card, title, productPath);
    }
  }

  function observeRebuy(wrap) {
    if (wrap.__recRebuyObserver) return;

    var observer = new MutationObserver(function(mutations) {
      var isOnlyOurTags = true;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && !added[j].classList.contains('rebuy-product-vendor')) {
            isOnlyOurTags = false;
            break;
          }
        }
        if (!isOnlyOurTags) break;
      }
      
      if (isOnlyOurTags) return;

      enrichRebuyCards(wrap);
      reconcileEmpty(wrap);
    });
    
    observer.observe(wrap, { childList: true, subtree: true });
    wrap.__recRebuyObserver = observer;

    setTimeout(function() {
      if (wrap.__recRebuyObserver) {
        wrap.__recRebuyObserver.disconnect();
        wrap.__recRebuyObserver = null;
      }
    }, REBUY_SETTLE);
  }

  // wrap is ready when widget or list is there
  function isWrapReady(wrap) {
    return !!(
      wrap.querySelector('.rebuy-widget-content') ||
      wrap.querySelector('.flickity-enabled') ||
      wrap.querySelector('.ProductList--grid') ||
      wrap.querySelector('.ProductList--carousel .Carousel__Cell')
    );
  }

  function hasVisibleProducts(wrap) {
    var rebuyWidget = wrap.querySelector('[data-rebuy-id]');
    if (rebuyWidget) {
      return !!rebuyWidget.querySelector('.rebuy-product-block');
    }
    return !!wrap.querySelector('.Carousel__Cell, .Grid__Cell');
  }

  function reconcileEmpty(wrap) {
    if (hasVisibleProducts(wrap)) {
      var wasEmpty = wrap.classList.contains('is-empty');
      wrap.classList.remove('is-empty');

      if (wasEmpty) {
        requestAnimationFrame(function() {
          window.dispatchEvent(new Event('resize'));
        });
      }
    } else {
      wrap.classList.add('is-empty');
    }
  }

  function reveal(wrap) {
    var held = Date.now() - (wrap.__recStart || 0);
    var wait = Math.max(0, MIN_LOADER_MS - held);
    setTimeout(function() { wrap.classList.add('is-loaded'); }, wait);
  }

  function markLoaded(wrap) {
    if (wrap.__recLoaded) return;
    wrap.__recLoaded = true;
    enrichRebuyCards(wrap);
    observeRebuy(wrap);

    reconcileEmpty(wrap);
    reveal(wrap);

    if (wrap.__recObserver) { wrap.__recObserver.disconnect(); wrap.__recObserver = null; }
    if (wrap.__recTimer) { clearTimeout(wrap.__recTimer); wrap.__recTimer = null; }
  }

  function initWrap(wrap) {
    if (wrap.__recInit) return;
    wrap.__recInit = true;
    wrap.__recStart = Date.now();

    // already rendered
    if (isWrapReady(wrap)) {
      markLoaded(wrap);
      return;
    }

    var observer = new MutationObserver(function() {
      if (isWrapReady(wrap)) markLoaded(wrap);
    });
    
    observer.observe(wrap, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    wrap.__recObserver = observer;

    wrap.__recTimer = setTimeout(function() {
      markLoaded(wrap);
    }, SAFETY_TIMEOUT);
  }

  function scan(root) {
    var scope = root || document;
    if (scope.nodeType === 1 && scope.matches('.rec-wrap[data-rec-loader]')) initWrap(scope);
    var wraps = scope.querySelectorAll ? scope.querySelectorAll('.rec-wrap[data-rec-loader]') : [];
    for (var i = 0; i < wraps.length; i++) initWrap(wraps[i]);
  }

  // first scan
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function(event) { scan(event.target); });

  var root = document.body || document.documentElement;
  if (root && 'MutationObserver' in window) {
    var lateObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    });
    lateObserver.observe(root, { childList: true, subtree: true });
  }
})();
